import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faChevronRight, faExpand, faTimes } from '@fortawesome/free-solid-svg-icons';
import './ComicViewer.css';

const ComicViewer = ({ comicId, images, title }) => {
  const [currentPage, setCurrentPage] = useState(0);
  const [isFullscreen, setIsFullscreen] = useState(false);

  const goToNextPage = () => {
    if (currentPage < images.length - 1) {
      setCurrentPage(currentPage + 1);
    }
  };

  const goToPrevPage = () => {
    if (currentPage > 0) {
      setCurrentPage(currentPage - 1);
    }
  };

  const toggleFullscreen = () => {
    setIsFullscreen(!isFullscreen);
  };

  const handleKeyDown = (e) => {
    if (e.key === 'ArrowRight') goToNextPage();
    if (e.key === 'ArrowLeft') goToPrevPage();
    if (e.key === 'Escape') setIsFullscreen(false);
  };

  return (
    <div
      className={`comic-viewer ${isFullscreen ? 'fullscreen' : ''}`}
      onKeyDown={handleKeyDown}
      tabIndex={0}
    >
      <div className="comic-header">
        <h3>{title}</h3>
        <div className="comic-controls">
          <span className="page-counter">
            {currentPage + 1} / {images.length}
          </span>
          <button onClick={toggleFullscreen} className="fullscreen-btn" title="전체화면">
            <FontAwesomeIcon icon={isFullscreen ? faTimes : faExpand} />
          </button>
        </div>
      </div>

      <div className="comic-content">
        <button
          onClick={goToPrevPage}
          disabled={currentPage === 0}
          className="nav-btn prev-btn"
          aria-label="이전 페이지"
        >
          <FontAwesomeIcon icon={faChevronLeft} />
        </button>

        <div className="comic-image-container">
          <img
            src={images[currentPage]}
            alt={`${title} - ${currentPage + 1}페이지`}
            className="comic-image"
          />
        </div>

        <button
          onClick={goToNextPage}
          disabled={currentPage === images.length - 1}
          className="nav-btn next-btn"
          aria-label="다음 페이지"
        >
          <FontAwesomeIcon icon={faChevronRight} />
        </button>
      </div>

      <div className="comic-thumbnails">
        {images.map((img, idx) => (
          <div
            key={idx}
            className={`thumbnail ${idx === currentPage ? 'active' : ''}`}
            onClick={() => setCurrentPage(idx)}
          >
            <img src={img} alt={`페이지 ${idx + 1}`} />
            <span className="thumbnail-number">{idx + 1}</span>
          </div>
        ))}
      </div>

      <div className="comic-navigation">
        <button
          onClick={goToPrevPage}
          disabled={currentPage === 0}
          className="nav-button"
        >
          <FontAwesomeIcon icon={faChevronLeft} /> 이전
        </button>
        <div className="page-dots">
          {images.map((_, idx) => (
            <span
              key={idx}
              className={`dot ${idx === currentPage ? 'active' : ''}`}
              onClick={() => setCurrentPage(idx)}
            />
          ))}
        </div>
        <button
          onClick={goToNextPage}
          disabled={currentPage === images.length - 1}
          className="nav-button"
        >
          다음 <FontAwesomeIcon icon={faChevronRight} />
        </button>
      </div>
    </div>
  );
};

export default ComicViewer;
